module.exports = __webpack_public_path__ + "static/media/pdf.d9f45755.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/icons/pdf.svg
// module id = 469
// module chunks = 0